var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_18059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3H12C11.45 3 11 3.45 11 4V5.61C11 5.61 11 5.61 11.01 5.62L16.01 10.12C16.64 10.68 17 11.5 17 12.35V13H19V15H17V17H19V19H17V21H20C20.55 21 21 20.55 21 20V4C21 3.45 20.55 3 20 3ZM15 7H13V5H15V7ZM19 11H17V9H19V11ZM19 7H17V5H19V7Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20V12.35C15 12.07 14.88 11.8 14.67 11.61L9.67 7.10998C9.48 6.92998 9.24 6.84998 9 6.84998C8.76 6.84998 8.52 6.93998 8.33 7.10998L3.33 11.61C3.12 11.79 3 12.06 3 12.35V20C3 20.55 3.45 21 4 21H6C6.55 21 7 20.55 7 20V16H11V20C11 20.55 11.45 21 12 21H14C14.55 21 15 20.55 15 20Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_18059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWork);
export default __webpack_public_path__ + "static/media/home_work.1c46288a34fac384401a7132d7424fd7.svg";
export { ForwardRef as ReactComponent };